import { render, staticRenderFns } from "./SettingsDashboard.vue?vue&type=template&id=01f6d2c8&scoped=true&lang=pug"
import script from "./SettingsDashboard.vue?vue&type=script&lang=js"
export * from "./SettingsDashboard.vue?vue&type=script&lang=js"
import style0 from "./SettingsDashboard.vue?vue&type=style&index=0&id=01f6d2c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f6d2c8",
  null
  
)

export default component.exports